/*
 * @Date: 2025-02-10 11:00:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-05-23 11:03:28
 * @FilePath: \zeelool-nextjs\src\components\GoodsDetail\handleData.ts
 * @Description: 描述
 */
import { IPointsMallProductDetail } from '@/api/types/account';
import { IGoodsDetail } from '@/api/types/public';
import { deepClone } from '@/utils/tools';

/**
 * @description: 处理轮播图数据
 * @param {*} detail
 * @return {*}
 */
const isArray = (arr: any[]) => Array.isArray(arr);

type ProductDetail = IGoodsDetail['product'] | IPointsMallProductDetail;

export const handleTopCarouselData = (detail: ProductDetail = {}) => {
  let carouselDataFlag = false;
  let showTabBtn = false;
  const productDetail = deepClone(detail) as any;
  const {
    image: {
      video = [],
      celebrity = [],
      product = [],
      material = [],
      product_detail = [],
      product_gray = [],
    } = {},
  } = productDetail || {};

  // 检查是否有任何一组图片不为空
  const hasModeledContent =
    (isArray(video) && video.length > 0) || (isArray(celebrity) && celebrity.length > 0);
  const hasProductContent =
    (isArray(product_gray) && product_gray.length > 0) ||
    (isArray(product) && product.length > 0) ||
    (isArray(material) && material.length > 0) ||
    (isArray(product_detail) && product_detail.length > 0);

  // 当有模特内容（视频/网红图）和产品内容（商品图/素材图/细节图）时显示标签
  showTabBtn = hasModeledContent && hasProductContent;

  isArray(video) &&
    video.forEach((elm, index) => {
      productDetail.image.video[index] = {
        url: elm,
        type: 'Modeled',
        styleStype: 'square',
        goodsType: 'video',
      };
    });
  // 镜框类型下的方图处理成长图
  if (isArray(product_gray) && product_gray.length > 0) {
    product_gray.forEach((elm, index) => {
      productDetail.image.product_gray[index] = {
        url: elm,
        type: 'Product',
        styleStype: productDetail.is_glass === 1 ? 'rect' : 'square',
        goodsType: 'product_gray',
      };
    });
  }
  // 镜框类型下的方图处理成长图
  isArray(product) &&
    product.forEach((elm, index) => {
      productDetail.image.product[index] = {
        url: elm,
        type: 'Product',
        styleStype: productDetail.is_glass === 1 ? 'rect' : 'square', // 饰品图片也属于Product
        goodsType: 'product',
      };
    });
  isArray(material) &&
    material.forEach((elm, index) => {
      productDetail.image.material[index] = {
        url: elm,
        type: 'Product',
        styleStype: 'square',
        goodsType: 'material',
      };
    });
  isArray(celebrity) &&
    celebrity.forEach((elm, index) => {
      productDetail.image.celebrity[index] = {
        url: elm,
        type: 'Modeled',
        styleStype: 'square',
        goodsType: 'celebrity',
      };
    });
  // 商品细节图
  if (product_detail) {
    isArray(product_detail) &&
      product_detail.forEach((elm, index) => {
        productDetail.image.product_detail[index] = {
          url: elm,
          type: 'Product',
          styleStype: 'square',
          goodsType: 'product_detail',
        };
      });
  }

  const img_order = productDetail.image_order;
  // Product，展示商品图product和素材图material
  // Modeled，展示视频video和网红图celebrity
  const new_img_order: string[] = [];

  const productIndex = img_order.findIndex((el: string) => el === 'product');
  const materialIndex = img_order.findIndex((el: string) => el === 'material');
  const videoIndex = img_order.findIndex((el: string) => el === 'video');
  const celebrityIndex = img_order.findIndex((el: string) => el === 'celebrity');

  if (productIndex < materialIndex) {
    new_img_order[0] =
      isArray(product_gray) && product_gray.length > 0 ? 'product_gray' : 'product';
    new_img_order[1] = 'product_detail';
    new_img_order[2] = 'material';
  } else {
    new_img_order[0] = 'material';
    new_img_order[1] =
      isArray(product_gray) && product_gray.length > 0 ? 'product_gray' : 'product';
    new_img_order[2] = 'product_detail';
  }
  if (videoIndex < celebrityIndex) {
    new_img_order[3] = 'video';
    new_img_order[4] = 'celebrity';
  } else {
    new_img_order[3] = 'celebrity';
    new_img_order[4] = 'video';
  }

  productDetail.imageList = new_img_order
    .map((key) => (productDetail.image[key] ? productDetail.image[key] : []))
    .flat();

  carouselDataFlag = true;
  // console.log('handleTopCarouselData', productDetail)
  return {
    productDetail,
    carouselDataFlag,
    showTabBtn,
  };
};

export interface IImageListItem {
  url?: string;
  type?: string;
  styleStype?: string;
  goodsType?: string;
}
